import { InlineNotification, Modal, TextInput } from "carbon-components-react";
import { useEffect, useState } from "react";

export const GeneralDeleteModalTextBlock = ({ children }) => {
    return <div style={{ marginTop: "1rem" }}>{children}</div>;
};

const GeneralDeleteModal = (props) => {
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [deleteModalErrors, setDeleteModalErrors] = useState([]);
    const [deleteModalPassphrase, setDeleteModalPassphrase] = useState("");

    useEffect(() => {
        setDeleteModalOpen(props.open);
    }, [props.open]);

    useEffect(() => {
        setDeleteModalErrors(props.deleteModalErrors);
    }, [props.deleteModalErrors]);

    const getPassPhrase = () => {
        return props.passPhrase || "delete permanently";
    };

    const deleteModalPrimearyButtonDisabled = () => {
        return (
            deleteModalPassphrase?.toLowerCase().trim() !== getPassPhrase() ||
            deleting
        );
    };
    const closeDeleteModal = (deleted) => {
        setDeleteModalErrors();
        setDeleteModalPassphrase("");
        props.onRequestClose(deleted);
    };

    const deleteItem = async () => {
        setDeleting(true);
        try {
            await props.onDelete();
            closeDeleteModal(true);
        } catch (e) {
            console.log(e);
            setDeleteModalErrors(
                [e.message, e.response?.data?.message].map((item) => (
                    <div>{item}</div>
                ))
            );
        } finally {
            setDeleting(false);
        }
    };

    const getItemType = () => {
        return props.itemType || "item";
    };

    return (
        <Modal
            open={deleteModalOpen}
            modalHeading={
                props.customHeader
                    ? props.customHeader
                    : deleting
                    ? "Deleting " + getItemType() + ", please wait"
                    : "Delete " + getItemType()
            }
            primaryButtonDisabled={deleteModalPrimearyButtonDisabled()}
            size="sm"
            danger={true}
            primaryButtonText={deleting ? "Wait..." : "Confirm"}
            secondaryButtonText={"Close"}
            onRequestSubmit={deleteItem}
            onRequestClose={closeDeleteModal}
        >
            {props.mainText || (
                <GeneralDeleteModalTextBlock>
                    This is a destructive action. Selected item will be deleted{" "}
                    <strong>permanently</strong>.<br />
                    Are you sure to want to continue?
                </GeneralDeleteModalTextBlock>
            )}
            <GeneralDeleteModalTextBlock>
                To confirm type <em>{getPassPhrase()}</em> and click the{" "}
                <em>Confirm</em> button
            </GeneralDeleteModalTextBlock>
            {deleteModalErrors && (
                <InlineNotification title="" kind="error" lowContrast>
                    <div>{deleteModalErrors}</div>
                </InlineNotification>
            )}
            {deleteModalOpen ? (
                <GeneralDeleteModalTextBlock>
                    <TextInput
                        id="passphrase"
                        // labelText="delete permanently"
                        placeholder={getPassPhrase()}
                        // value=""
                        onChange={(e) =>
                            setDeleteModalPassphrase(e.target.value)
                        }
                    />
                </GeneralDeleteModalTextBlock>
            ) : null}
        </Modal>
    );
};

export default GeneralDeleteModal;
